import { Box, IconButton } from "@mui/material"
import { alpha } from "@mui/material/styles"
import { SnackbarProvider as NotistackProvider } from "notistack"
import type { SnackbarKey } from "notistack"
import { useRef } from "react"

import Iconify from "../iconify"
import StyledNotistack from "./styles"

export default function SnackbarProvider({ children }: { children: React.ReactNode }) {
  const notistackRef = useRef<React.ElementRef<typeof NotistackProvider>>(null)

  const onClose = (key: SnackbarKey) => () => {
    notistackRef.current?.closeSnackbar(key)
  }

  return (
    <>
      <StyledNotistack />

      <NotistackProvider
        ref={notistackRef}
        dense
        maxSnack={5}
        preventDuplicate
        autoHideDuration={3000}
        variant="success" // Set default variant
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        iconVariant={{
          info: <SnackbarIcon icon="eva:info-fill" color="info" />,
          success: <SnackbarIcon icon="eva:checkmark-circle-2-fill" color="success" />,
          warning: <SnackbarIcon icon="eva:alert-triangle-fill" color="warning" />,
          error: <SnackbarIcon icon="eva:alert-circle-fill" color="error" />,
        }}
        // With close as default
        action={(key) => (
          <IconButton size="small" onClick={onClose(key)} sx={{ p: 0.5, mr: 1 }}>
            <Iconify icon="eva:close-fill" sx={{ p: 0, color: "action.active" }} width={20} />
          </IconButton>
        )}
      >
        {children}
      </NotistackProvider>
    </>
  )
}

function SnackbarIcon({
  icon,
  color,
}: {
  icon: string
  color: "primary" | "secondary" | "info" | "success" | "warning" | "error"
}) {
  return (
    <Box
      component="span"
      sx={{
        mr: 1.5,
        width: 40,
        height: 40,
        display: "flex",
        borderRadius: 1.5,
        alignItems: "center",
        justifyContent: "center",
        color: `${color}.main`,
        bgcolor: (theme) => alpha(theme.palette[color].main, 0.16),
      }}
    >
      <Iconify icon={icon} width={24} />
    </Box>
  )
}
